<nav class="h-[72px] bg-shui-base-1 flex items-center justify-between px-4 md:px-8 relative">
    <!-- Logo -->
    <div class="flex items-center cursor-pointer" data-testid="global-header-button-home" [routerLink]="'/'">
        <img
            src="assets/images/healthineers-logo/healthineers-logo-black.svg"
            alt="Siemens Healthineers"
            class="h-[32px] [html[theme='dark']_&]:hidden"
        />
        <img
            src="assets/images/healthineers-logo/healthineers-logo-white.svg"
            alt="Siemens Healthineers"
            class="h-[32px] hidden [html[theme='dark']_&]:block"
        />
        <span class="text-shui-text-active text-base font-semibold ml-4 items-end hidden md:flex whitespace-nowrap">
            My Digital Lab Assistant
            <span class="text-shui-text-subtle text-xs/5 whitespace-nowrap font-thin ml-2"> v{{ version() }} </span>
        </span>
    </div>

    <!-- Desktop nav items -->
    <div class="hidden md:flex items-center gap-6">
        <app-theme-switcher></app-theme-switcher>
        <ng-content select="[desktopItems]"></ng-content>
        @if (isAdmin()) {
            <sh-icon
                icon="panel"
                size="s"
                id="navbar-admin"
                class="cursor-pointer text-shui-text-subtle"
                [routerLink]="['admin']"
            ></sh-icon>
            <sh-tooltip label="Admin" target="navbar-admin" placement="bottom" variation="short"></sh-tooltip>
        }
        @if (userName()) {
            <sh-user-identifier
                [name]="userName()!"
                [info]="userInfo() ?? ''"
                [attr.readonly]="true"
                id="user-identifier"
                slot="user"
            ></sh-user-identifier>
        }
    </div>

    <!-- Mobile: initials + hamburger -->
    <div class="flex md:hidden items-center gap-4">
        @if (userInitials()) {
            <div
                class="w-8 h-8 rounded-full bg-shui-base-4 text-shui-text-active text-sm font-semibold flex items-center justify-center"
                id="user-initials-mobile"
            >
                {{ userInitials() }}
            </div>
        }
        <button
            (click)="toggleMobileMenu()"
            class="text-shui-text-subtle focus:outline-none bg-transparent border-none"
            aria-label="Toggle menu"
        >
            <sh-icon [icon]="mobileMenuOpen() ? 'cancel' : 'menu'" size="s"></sh-icon>
        </button>
    </div>

    <!-- Mobile dropdown menu -->
    @if (mobileMenuOpen()) {
        <div
            class="absolute top-[72px] left-0 right-0 bg-shui-base-0 border-t border-shui-base-4 flex flex-col gap-2 px-4 py-4 z-50 md:hidden shadow-lg"
        >
            <span class="text-shui-text-active text-sm font-semibold mb-1">
                My Digital Lab Assistant
                <span class="text-shui-text-subtle text-xs font-thin ml-1">v{{ version() }}</span>
            </span>
            <app-theme-switcher [showLabel]="true"></app-theme-switcher>
            <ng-content select="[mobileItems]"></ng-content>
            @if (isAdmin()) {
                <span
                    class="cursor-pointer text-shui-text-subtle flex items-center gap-2 py-2"
                    [routerLink]="['admin']"
                    (click)="toggleMobileMenu()"
                >
                    <sh-icon icon="panel" size="s" class="text-shui-text-subtle"></sh-icon>
                    Admin
                </span>
            }
        </div>
    }
</nav>
